export default __webpack_public_path__ + "static/media/contacto1152px.ed551955.jpg";